import mixpanel from 'mixpanel-browser';

import { PageName } from './events';
import { EnvVars } from '../../environment';
import { User } from '@/api/types/backend-dto-types';

let isInitialized = false;

const isProduction = EnvVars.ENVIRONMENT.startsWith('production');

if (isProduction) {
  try {
    mixpanel.init('895d76aa353309f28cdbbee9432886e8', {
      debug: true,
      persistence: 'localStorage',
    });
    isInitialized = true;
  } catch (error) {
    console.error('Failed to initialize Mixpanel:', error);
  }
}

export const trackUser = (user: User | null) => {
  if (isProduction && isInitialized) {
    try {
      mixpanel.identify(user?.id);
      mixpanel.people.set({
        $email: user?.email,
      });
    } catch (error) {
      console.error('Failed to track user:', error);
    }
  }
};

export const trackCustomEvent = (eventName: string, properties = {}) => {
  if (isProduction && isInitialized) {
    try {
      mixpanel.track(eventName, properties);
    } catch (error) {
      console.error('Failed to track custom event:', error);
    }
  }
};

export const trackPageView = (pageName: PageName) => {
  if (isProduction && isInitialized) {
    mixpanel.track(`Page View ${pageName}`);
  }
};

export default mixpanel;
